export default {
  getLoading: (state) => state.loading,
  getTerm: (state) => state.term,
  getActivateTermInEdit: (state) => state.activateTermInEdit,
  getTermViewOnly: (state) => state.viewOnlyTerm,
  getCreatingTerm: (state) => state.creatingTerm,
  getCurrentStep: (state) => state.currentStep,
  getLayout: (state) => state.layout,
  getCoverageOptions: (state) => state.coverageOptions,
  getCoverageCityStateSelected: (state) => state.cityStateSelected,
  getCoverageCitySelecteds: (state) => state.citiesSelecteds
}
